import { motion } from 'framer-motion';
import React from 'react';
import { ChartProvider } from './ChartProvider';
import RenderChart from './RenderChart';

export const CubeChart: React.FC = () => {
  return (
    /**
     * For responsive styling see this post:
     * https://stackoverflow.com/questions/57385938/how-to-get-react-chartjs-to-resize-back-down-with-window
     */
    <ChartProvider>
      <motion.div
        layout
        style={{ width: '99%', height: '99%', position: 'relative' }}
      >
        <RenderChart chartType='bar' />
      </motion.div>
    </ChartProvider>
  );
};
